module.exports = __webpack_public_path__ + "static/media/Avatar_Active.b44b6b87.svg";